import type { VisualSectionModel } from "./types";

export function normalizeAllyCode(value: string): string | null {
  const allyCode = value.trim().replace(/[\s-]/g, "");
  return /^\d{9}$/.test(allyCode) ? allyCode : null;
}

export function allyCodeFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/p\/(\d{9})\/?$/);
  return match?.[1] ?? null;
}

export function playerPath(allyCode: string): string {
  return `/p/${allyCode}`;
}

export function formatDuration(milliseconds: number): string {
  return milliseconds < 1_000 ? `${Math.round(milliseconds)}ms` : `${(milliseconds / 1_000).toFixed(1)}s`;
}

export function visibleSections(sections: VisualSectionModel[], tag: string, query: string): VisualSectionModel[] {
  const normalizedQuery = query.trim().toLowerCase();
  return sections.flatMap((section) => {
    if (tag !== "all" && !(section.tags ?? []).includes(tag)) return [];
    const squads = normalizedQuery
      ? section.squads.filter((squad) => [squad.title, ...squad.cards.map((card) => card.name), ...squad.metrics, ...(squad.requiredUpgrades ?? [])].join(" ").toLowerCase().includes(normalizedQuery))
      : section.squads;
    return squads.length ? [{ ...section, squads }] : [];
  });
}
